import { createSvgComponent } from "../../icon/createSvgComponent";
import Home2 from "@core/__generated__/icon/figma/home2.svg";
export default createSvgComponent(Home2);